import React from "react";

import { Title } from "Cobalt/Header";
import { StandaloneTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import Button from "Common/Button";

import DisabilityCostBreakdownBody from "./DisabilityCostBreakdownBody";

const DisabilityCostBreakdownModal = ({ plan, triggerText, headerText, triggerClassName, footer, trackOpen }) => (
  <StandaloneTrigger
    trigger={(props) => (
      <a
        className={triggerClassName}
        href="#"
        onClick={(e) => {
          props.onClick(e);
          if (trackOpen) trackOpen();
        }}
        {...props}
      >
        {triggerText}
      </a>
    )}
    modal={(props) => (
      <Modal className="DisabilityPriceBreakdown" {...props}>
        <ModalHeader closeButton>
          <Title mb={2}>{headerText || "Price Breakdown"}</Title>
        </ModalHeader>
        <ModalBody>
          <DisabilityCostBreakdownBody plan={plan} />
        </ModalBody>
        <ModalFooter>
          {footer ? (
            footer(props.onHide)
          ) : (
            <Button key="close" onClick={() => props.onHide()}>
              Close
            </Button>
          )}
        </ModalFooter>
      </Modal>
    )}
  />
);

export default DisabilityCostBreakdownModal;
